angular.module('impactx.MenuDirectives').controller('HighContrastCtrl', ['$scope', '$workspace', 'TranslationService', 'AppConfiguration', HighContrastCtrl]);
function HighContrastCtrl($scope, $workspace, TranslationService, AppConfiguration)
{
    this.translationService = TranslationService;
    this.show = AppConfiguration.get("highContrastAvailable");

    this.switchHighContrast = function () {
        $workspace.setHighContrastActive(!$workspace.getHighContrastActive());
    }
}